import React, { useState } from "react";
import { Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
// import TopicForm from "../../components/topic/TopicForms";
import TopicForm from "../../components/topic/TopicForms";
import AddIcon from "@material-ui/icons/Add";
import Close from "@material-ui/icons/Close";

export default function CreateTopicModal({
  handleSubmit,
  category,
  isPopupOpen,
  closePopup,
  openPopup,
}) {
  return (
    <>
      <button className="HeaderTablesDiv1Btn1 mt-2" onClick={openPopup}>
        <div className="textStyle">Create Topic</div>
        <AddIcon />
      </button>

      <Dialog open={isPopupOpen} onClose={closePopup} maxWidth="lg" fullWidth>
        <div className="popup" style={{ padding: "20px" }}>
          <div className="d-flex justify-content-between align-items-center">
            <Typography variant="h4" style={{ margin: 10, padding: 5 }}>
              Create Topic
            </Typography>
            <Close onClick={closePopup} />
          </div>
          <TopicForm onSubmit={handleSubmit} topicCategory={category} />
        </div>
      </Dialog>
    </>
  );
}
